<template>
  <div>
    <div class="row">
      <div class="col-8">
        <h1>Criação de nó</h1>
      </div>
      <div class="col-4" style="text-align: right">
        <md-button
          class="md-icon-button md-list-action"
          @click="() => $emit('close')"
        >
          <md-icon>close</md-icon>
          <md-tooltip md-direction="left"> Voltar</md-tooltip>
        </md-button>
      </div>
      <div v-if="position != null" class="col-12">
        <md-button
          class="md-primary md-raised"
          :disabled="loading"
          @click="criarNo"
        >
          Salvar
        </md-button>

        <md-progress-spinner
          v-if="loading"
          class="mt-2"
          :md-diameter="30"
          :md-stroke="4"
          md-mode="indeterminate"
        />
      </div>
    </div>
    <div v-if="position == null">
      <span> Selecione um ponto no mapa para criar um nó</span>
    </div>

    <div v-else>
      <span>
        Ponto selecionado: {{ position.x.toFixed(6) }},
        {{ position.y.toFixed(6) }}</span
      >
    </div>

    <md-table>
      <md-table-row>
        <md-table-head>Propriedade</md-table-head>
        <md-table-head md-numeric>Valor</md-table-head>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Uid</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label>Uid</label>
              <md-input v-model="form.uid" style="text-align: right"></md-input>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Tipo</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label for="data">Tipo</label>
              <md-select id="tipo" v-model="form.tipo" name="tipo">
                <md-option :value="0"> Junção</md-option>
                <md-option :value="1"> Reservatório</md-option>
              </md-select>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Padrão de consumo</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label for="data">Padrão de consumo</label>
              <md-select id="tipo" v-model="form.pattern" name="tipo">
                <md-option v-for="p in consumos" :key="p.uid" :value="p.index">
                  {{ p.uid }} - {{ p.value }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Elevação</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label>Elevação</label>
              <md-input
                v-model.number="form.elevacao"
                style="text-align: right"
                number
              ></md-input>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import { EventBus, Topics, Types } from '@/event-bus'
import http from '@/utils/http'

export default {
  name: 'EpanetCreateNode',
  props: {
    position: {
      type: Object,
      default: null,
    },
    consumos: {
      type: Array,
      default: () => [],
    },
    simulacaoId: {
      type: String,
      required: true,
    },
    nodes: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      changed: {},
      form: {
        uid: '',
        tipo: 0,
        elevacao: 0,
        pattern: 0,
      },
    }
  },
  watch: {
    nodes: {
      handler(newV, oldV) {
        if (newV !== oldV) {
          this.form.uid = `J` + (Object.keys(this.nodes).length + 1) * 2
        }
      },
      deep: true,
    },
  },
  beforeMount() {
    this.form.uid = this.findNextId()
  },
  methods: {
    findNextId() {
      const re = /^FJ\d*/

      let maxId = 0

      Object.keys(this.nodes).forEach((e) => {
        if (re.test(e)) {
          const id = parseInt(e.replace('FJ', ''), 10)
          if (id > maxId) {
            maxId = id
          }
        }
      })

      return `FJ${maxId + 1}`
    },
    async criarNo() {
      if (this.form.uid === '') {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um id para o nó',
        })
        return
      }

      if (this.nodes[this.form.uid] != null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Id já existe',
        })
        return
      }

      if (this.position == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um ponto no mapa',
        })
        return
      }

      if (this.form.tipo == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um tipo de nó',
        })
        return
      }

      if (this.form.pattern == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um padrão de consumo',
        })
        return
      }

      if (this.form.elevacao == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione uma elevação',
        })
        return
      }

      if (this.form.elevacao < 0) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Elevação deve ser maior que zero',
        })
        return
      }

      // eslint-disable-next-line no-unreachable
      const response = await http.post(
        `epanet/simulacao/${this.simulacaoId}/node`,
        {
          uid: this.form.uid,
          tipo: this.form.tipo,
          elevacao: this.form.elevacao,
          x: this.position.x,
          y: this.position.y,
        }
      )

      if (+response === 1) {
        if (this.form.tipo === 0) {
          const changeResponse = await http.post(
            'epanet/simulacao/change',
            {
              tipo: 'PCP',
              simulacaoId: this.simulacaoId,
              uid: this.form.uid,
              dados: {
                elevation: this.form.elevacao,
              },
            },
            false
          )

          if (!changeResponse) {
            EventBus.$emit(Topics.NOTIFICATIONS, {
              type: Types.WARNING,
              message: 'Erro ao criar nó',
            })
          }
        }

        this.$emit('save')
      }
    },
  },
}
</script>
